import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PRCaricaFatturaComponent } from './pr-carica-fattura';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pr-carica-fattura', {
            url: '/pr-carica-fattura',
            ncyBreadcrumb: {
                label: 'Carica Fattura',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Carica fattura XML'
            },
            'views': {
                'homeContent': {
                    template: '<pr-carica-fattura flex="100"></pr-carica-fattura>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PRCaricaFatturaModule: string = ng
    .module('pr-carica-fattura', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('prCaricaFattura', PRCaricaFatturaComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-carica-fattura/pr-carica-fattura.module.ts